import React, { useContext } from "react";
import IsMobileContext from "../../../context/isMobile/isMobileContext";
import EditarDispositivoMovil from "./EditarDispositivoMovil";
import EditarDispositivoWeb from "./EditarDispositivoWeb";

export default function CrearUsuario(props) {
  const isMobile = useContext(IsMobileContext);
  const { isMobileUse } = isMobile;
  return (
    <>
      {isMobileUse() ? (
        <EditarDispositivoMovil
          data={props.data}
          update={props.update}
          setOpen={props.setOpen}
          refreshUs={props.refreshUs}
        />
      ) : (
        <EditarDispositivoWeb
          data={props.data}
          update={props.update}
          setOpen={props.setOpen}
          refreshUs={props.refreshUs}
        />
      )}
    </>
  );
}
